import React, { useRef } from "react";
import MapTemplate from "../templates/map/MapTemplate";
import useMapLayers from "../hooks/mapScreen/useMapLayers.js";
import useHistoricFires from "../hooks/mapScreen/useHistoricFires.js";
import useAnalysisWorkflow from "../hooks/mapScreen/useAnalysisWorkflow.js";
import useAnalysesHistory from "../hooks/mapScreen/useAnalysesHistory.js";
import useAnalysisViewer from "../hooks/mapScreen/useAnalysisViewer.js";
import { useAuth } from "../context/AuthContext.js";

const MapScreen = () => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const { logout } = useAuth();

  const layers = useMapLayers(mapRef);
  const analysis = useAnalysisWorkflow();
  const historic = useHistoricFires(analysis.setRealPolygon);
  const viewer = useAnalysisViewer();
  const history = useAnalysesHistory(viewer.forgetAnalysis);

  const resetAnalysis = () => {
    historic.cancelSelection(); // ignore a historic polygon still loading
    analysis.resetAnalysis();
  };

  return (
    <MapTemplate
      mapContainerRef={mapContainerRef}
      mapRef={mapRef}
      logout={logout}
      // ---- layers ----
      biomass={layers.biomass}
      onShowBiomass={layers.onShowBiomass}
      forest={layers.forest}
      onShowForest={layers.onShowForest}
      buildings={layers.buildings}
      onShowBuildings={layers.onShowBuildings}
      grassland={layers.grassland}
      onShowGrassland={layers.onShowGrassland}
      shrubland={layers.shrubland}
      onShowShrubland={layers.onShowShrubland}
      relief={layers.relief}
      toggleRelief={layers.toggleRelief}
      // ---- historic fires ----
      historicFires={historic.historicFires}
      onFetchHistoricFires={historic.fetchHistoricFires}
      onSelectHistoricFire={historic.selectHistoricFire}
      // ---- current analysis ----
      realPolygon={analysis.realPolygon}
      setRealPolygon={analysis.setRealPolygon}
      simPolygon={analysis.simPolygon}
      setSimPolygon={analysis.setSimPolygon}
      impacts={analysis.impacts}
      onLaunchAnalysis={analysis.launchAnalysis}
      cost={analysis.cost}
      onLaunchCost={analysis.launchCost}
      report={analysis.report}
      onLaunchReport={analysis.launchReport}
      onResetAnalysis={resetAnalysis}
      // ---- analyses history ----
      stats={history.stats}
      onFetchStats={history.fetchStats}
      statsIds={history.statsIds}
      onFetchStatsByIds={history.fetchStatsByIds}
      statsCandidates={history.statsCandidates}
      onFetchStatsCandidates={history.fetchStatsCandidates}
      analyses={history.analyses}
      onFetchAnalyses={history.fetchAnalyses}
      onDeleteAnalysis={history.deleteAnalysis}
      // ---- viewing a past analysis ----
      openingId={viewer.openingId}
      onOpenAnalysis={viewer.openAnalysis}
      viewed={viewer.viewed}
      onCloseViewed={viewer.closeViewed}
      reportPreview={viewer.reportPreview}
      onOpenReportPreview={viewer.openReportPreview}
      onCloseReportPreview={viewer.closeReportPreview}
    />
  );
};

export default MapScreen;
